
import { safeJsonParse } from "./utilities/safe-json-parse";

export const getCustomer = async () => {
    const session = safeJsonParse(window.localStorage.getItem("session"));
    if(!session || !session.session_token) {
        return;
    }

    try {
        const response = await fetch(`${fx_local_scripts.store_base_url}/s/customer`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                "FOXY-API-VERSION": "1",
                Authorization: `Bearer ${session.session_token}`
            },
        });

        if(!response.ok) {
            throw new Error(`Response error: ${response.status} ${response.statusText}`);
        }

        console.log("Got fx customer", response.status);
        return response.json();
    } catch (error) {
        console.error("Error getting fx customer", error);
    }
};

export const getCustomerOrder = async (user, currentVariant, orderType) => {
    if(!user._embedded || !user._embedded["fx:attributes"]) {
        return;
    }

    const orders = user._embedded["fx:attributes"];

    if(!orders) {
        return;
    }

    const parsedOrders = orders.map(
        (order) => safeJsonParse(order.value)
    ).filter(Boolean);


    if(!parsedOrders) {
        return;
    }

    const orderWithRedeemLink = parsedOrders.find((order) => {
        const {type, variant, download_url, status} = order;
        

        if(type !== orderType) {
            return false;
        }

        if(currentVariant !== variant) {
            return false;
        }
        
        // if order has been revoked show buy button again
        if(status === "revoked") {
            return false;
        }

        // if order has link
        return Boolean(download_url);
    });

    if(!orderWithRedeemLink) {
        return;
    }

    const timeStamp = Date.now();

    return `${orderWithRedeemLink.download_url}&s=${timeStamp}`;
};